import { memo, type PropsWithChildren } from 'react';

export type WorkspaceOnboardingCardProps = PropsWithChildren;

export const WorkspaceOnboardingCard = memo(({ children }: WorkspaceOnboardingCardProps) => {
  return (
    <div
      className="h-[645px] max-h-[90vh] w-[972px] max-w-[90vw] overflow-hidden rounded-16 bg-grey-1 shadow-modal"
      data-testid="WORKSPACE_ONBOARDING_FORM"
    >
      {children}
    </div>
  );
});

WorkspaceOnboardingCard.displayName = 'WorkspaceOnboardingCard';
